export enum InvoiceActionType {
  ATTACH,
  ARCHIVE,
  CANCELPROCESS,
  CANCELFORM,
  FORWARD,
  INJECTINVOICE,
  PICK,
  PROCESSINVOICE,
  RESET,
  SENDBACK,
  UNPICK,
  UPDATEINVOICE,
  VOUCHERVALIDATION,
  WORKFLOWSTAGEVALIDATION,
  WAITING,
  COMPLAINT,
  UNCOMPLAINT,
  MANUAL,
}
